import UserApi from '../api/user/user';
import AuthApi from '../api/auth';
import api from '../api';
import * as types from './mutation-types';
import * as cookies from '../config/cookies';
import Cookies from 'js-cookie';
import _ from 'lodash';

export const setUserByToken = _.throttle(
    function({ commit, state }) {
        return UserApi.profile(state.auth.token).then(data => {
            if (data) {
                commit(types.SET_USER, data.user);
                let root = document.documentElement;
                const userMainColor = data.user.sex === 'female' ? 'hsl(15, 100%, 64%)' : 'hsl(212, 100%, 56%)';
                const userHelpColor = data.user.sex === 'female' ? 'hsl(14, 91%, 58%)' : 'hsl(212, 100%, 48%)';
                root.style.setProperty('--user-main-color', userMainColor);
                root.style.setProperty('--user-help-color', userHelpColor);
            }
        });
    },
    500,
    { trailing: false }
);

export const setUserToken = function({ commit, dispatch }, token) {
    api.setToken(token);
    Cookies.set(cookies.USER_TOKEN, token);
    commit(types.SET_USER_TOKEN, token);
    return dispatch('setUserByToken');
};

export const signIn = function({ dispatch }, credentials) {
    return AuthApi.getUserTokenByCredentials(credentials).then(token => {
        return dispatch('setUserToken', token);
    });
};

export const logOut = function({ commit, dispatch }) {
    commit('setUser', null);
    commit('setCourse', null);
    if (Cookies.get(cookies.TEACHER_TOKEN)) {
        dispatch('setUserToken', Cookies.get(cookies.TEACHER_TOKEN)).then(() => {
            Cookies.remove(cookies.TEACHER_TOKEN);
        });
    } else if (Cookies.get(cookies.ADMIN_TOKEN)) {
        dispatch('setUserToken', Cookies.get(cookies.ADMIN_TOKEN)).then(() => {
            Cookies.remove(cookies.ADMIN_TOKEN);
        });
    } else if (Cookies.get(cookies.SUPERADMIN_TOKEN)) {
        dispatch('setUserToken', Cookies.get(cookies.SUPERADMIN_TOKEN)).then(() => {
            Cookies.remove(cookies.SUPERADMIN_TOKEN);
        });
    } else if (Cookies.get(cookies.MANAGER_TOKEN)) {
        dispatch('setUserToken', Cookies.get(cookies.MANAGER_TOKEN)).then(() => {
            Cookies.remove(cookies.MANAGER_TOKEN);
        });
    } else if (Cookies.get(cookies.SUPPORT_TOKEN)) {
        dispatch('setUserToken', Cookies.get(cookies.SUPPORT_TOKEN)).then(() => {
            Cookies.remove(cookies.SUPPORT_TOKEN);
        });
    } else {
        Cookies.remove(cookies.USER_TOKEN);
        window.sessionStorage.clear();
        commit(types.SET_USER_TOKEN, null);
        commit(types.SET_USER, null);
    }
};

export const setAuthUserAvatar = function({ commit, state }, avatar) {
    let user = state.auth.user;
    user.avatar = avatar;
    commit(types.SET_USER, user);
};

export const setHomework = function({ commit }, homework) {
    commit(types.SET_HOMEWORK, homework);
};

export const setHomeworkCopy = function({ commit }, homeworkCopy) {
    commit(types.SET_HOMEWORK_COPY, homeworkCopy);
};

export const setGamesParameters = function({ commit }, parameters) {
    commit(types.SET_GAMES_PARAMETERS, parameters);
};

export const setCourse = function({ commit }, course) {
    commit(types.SET_COURSE, course);
};

export const setLessonConductingTemplate = function({ commit }, template) {
    commit(types.SET_LESSON_CONDUCTING_TEMPLATE, template);
};

export const setGame = function({ commit }, game) {
    commit(types.SET_GAME, game);
};

export const setParamsArray = function({ commit }, paramsArray) {
    commit(types.SET_PARAMS_ARRAY, paramsArray);
};

export const setSearchParams = function({ commit }, searchParams) {
    commit(types.SET_SEARCH_PARAMS, searchParams);
};

export const setPreviousRoute = function({ commit }, previousRoute) {
    commit(types.SET_PREVIOUS_ROUTE, previousRoute);
};

export const setPuzzleGame = function({ commit }, data) {
    commit(types.SET_PUZZLE_GAME, data);
};

export const setPuzzleGamesParamsArray = function({ commit }, puzzleGamesParams) {
    commit(types.SET_PUZZLE_GAMES_PARAMS_ARRAY, puzzleGamesParams);
};
